module.exports = __webpack_public_path__ + "img/register-link.035f05c4.png";